export default "__VITE_ASSET__BwX8mqvf__"